var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "contents" }, [
    _vm.siteCode == _vm.$config.SITECODE_OGCBD ||
    _vm.siteCode == _vm.$config.SITECODE_OGHCM
      ? _c("div", { staticClass: "service" }, [
          _c("div", { staticClass: "cont-tit" }, [
            _c("h6", [
              _vm._v(_vm._s(/*빠른 서비스*/ _vm.$t("MMAIN-03-01-01-19")))
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "box-normal",
              on: {
                click: function($event) {
                  return _vm.goPage("1")
                }
              }
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    /*PC를 위한 모바일 OTP 확인서*/ _vm.$t("MMAIN-03-01-01-20")
                  ) +
                  " "
              ),
              _c("i", { staticClass: "icon icon-arrow-m-right" })
            ]
          )
        ])
      : _vm._e(),
    _c("div", { staticClass: "time-guide" }, [
      _c("div", { staticClass: "cont-tit" }, [
        _c("h6", [_vm._v(_vm._s(/*첫 가이드*/ _vm.$t("MMAIN-03-01-01-21")))])
      ]),
      _c("div", { staticClass: "box-normal" }, [
        _c(
          "div",
          {
            staticClass: "box-normal-col",
            on: {
              click: function($event) {
                return _vm.goPage("2")
              }
            }
          },
          [
            _c("i", { staticClass: "icon icon-time-guide01" }),
            _c("span", [_vm._v(_vm._s(/*예금상품*/ _vm.$t("MMENU-0015")))])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "box-normal-col",
            on: {
              click: function($event) {
                return _vm.goPage("3")
              }
            }
          },
          [
            _c("i", { staticClass: "icon icon-time-guide02" }),
            _c("span", [
              _vm._v(_vm._s(/*간편 로그인*/ _vm.$t("MMAIN-03-01-01-05")))
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass: "box-normal-col",
            on: {
              click: function($event) {
                return _vm.goPage("4")
              }
            }
          },
          [
            _c("i", { staticClass: "icon icon-time-guide03" }),
            _c("span", [_vm._v(_vm._s(/*FAQ*/ _vm.$t("MMENU-0033")))])
          ]
        )
      ])
    ]),
    _c("div", { staticClass: "help" }, [
      _c("div", { staticClass: "cont-tit" }, [
        _c("h6", [_vm._v(_vm._s(/*헬프데스크*/ _vm.$t("MMAIN-03-01-01-22")))])
      ]),
      _c("div", { staticClass: "box-normal" }, [
        _c("div", { staticClass: "header" }, [
          _c("div", { staticClass: "tit" }, [
            _vm._v(_vm._s(/*아이디/비밀번호 분실*/ _vm.$t("MMAIN-03-01-01-06")))
          ])
        ]),
        _c("div", { staticClass: "cont" }, [
          _c("ul", { staticClass: "ulist ulist-type--bullet" }, [
            _c("li", [
              _c("p", [
                _vm._v(
                  _vm._s(
                    /*아이디 찾기 메뉴에서 계좌인증으로 찾을 수 있습니다.*/ _vm.$t(
                      "MMAIN-03-01-01-07"
                    )
                  )
                )
              ])
            ]),
            _c("li", [
              _c("p", [
                _vm._v(
                  _vm._s(
                    /*비밀번호 변경 메뉴에서 계좌 인증과 OTP인증으로 변경하실 수 있습니다.*/ _vm.$t(
                      "MMAIN-03-01-01-09"
                    )
                  )
                )
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "bottom" }, [
          _c("div", { staticClass: "btn-area--bottom" }, [
            _c(
              "button",
              {
                staticClass: "btn sm outline",
                on: {
                  click: function($event) {
                    return _vm.goPage("5")
                  }
                }
              },
              [_vm._v(_vm._s(/*ID 찾기*/ _vm.$t("MMAIN-03-01-01-08")))]
            ),
            _c(
              "button",
              {
                staticClass: "btn sm outline",
                on: {
                  click: function($event) {
                    return _vm.goPage("6")
                  }
                }
              },
              [_vm._v(_vm._s(/*비밀번호 변경*/ _vm.$t("MMAIN-03-01-01-10")))]
            )
          ])
        ])
      ])
    ]),
    _vm.siteCode == _vm.$config.SITECODE_OGHCM
      ? _c("div", { staticClass: "cont-img logo" }, [
          _c("i", { staticClass: "icon img-DIV-logo" }),
          _c("span", { staticClass: "v-hidden" }, [
            _vm._v("Deposit insurance of Vietnam (DIV)")
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }